import * as yup from 'yup';
import { useFormik } from 'formik';
import { useCallback } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { FunctionalityVM } from 'system/view-models/functionality';
import Description from './description';
import Functionality from './functionality';

export interface GroupForm {
  code: string;
  name: string;
  lastUpdate: string;
  functionality?: Array<FunctionalityVM>;
}

interface FormDetailProps {
  onOk: (form?: GroupForm) => void;
  initialValues?: GroupForm;
  onCancel: () => void;
  disabled?: boolean;
  isEdit?: boolean;
  insert?: boolean;
  title?: string;
}
const validationSchema = yup.object({
  name: yup.string().nullable().required('Il campo è obbligatorio'),
});

const Detail = ({
  onOk,
  initialValues,
  onCancel,
  disabled,
  insert,
  isEdit,
  title,
}: FormDetailProps): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const groupForm = useFormik({
    initialValues: initialValues || {
      name: '',
      code: '',
      lastUpdate: '',
      groups: [],
      functionality: [],
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const onChange = useCallback(
    (functionalities) => groupForm.setFieldValue('functionality', functionalities),
    [groupForm.setFieldValue]
  );

  return (
    <div className="pmi-my-3">
      <form onSubmit={groupForm.handleSubmit}>
        <div>
          <Description
            errorDescriptionValue={groupForm.errors.name}
            touchedDescriptionValue={groupForm.touched.name}
            handleChange={groupForm.handleChange}
            descriptionValue={groupForm.values.name || ''}
            code={groupForm.values.code || ''}
            lastUpdate={groupForm.values.lastUpdate || ''}
            title={title}
            isEdit={isEdit}
            disabled={disabled}
          />
          <Functionality
            onChange={onChange}
            insert={insert}
            functionalities={groupForm.values.functionality || []}
            disabled={disabled}
          />
        </div>
        <div style={{ padding: '24px 0 16px 0' }}>
          <div className="pmi-mr-3 pmi-d-inline-block">
            <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
              Conferma
            </PmiButton>
          </div>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel();
            }}
          >
            Indietro
          </PmiButton>
        </div>
      </form>
    </div>
  );
};
Detail.displayName = 'Group detail component';

export default Detail;
